import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import UploadFileMarkupService from "../../services/UploadFileMarkupService/UploadFileMarkupService";
import { SHAPE_TYPE } from "../../constants/Constants";
import { MARKUP_MENU_TYPE } from "../../constants/MarkupConstants";
import markupService from "../../services/MarkupService/markupService";

const MarkupMenuItem = ({ iconClass, shapeType, selectedShapeType, handleClick, label, fromMarkup }) => {
    return (
        <div
            className={clsx("markup-menu-item", fromMarkup === MARKUP_MENU_TYPE.MARKUP_ANNOTATION && shapeType === SHAPE_TYPE.BLUR && "right-border")}
        >
            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                <button className={clsx("btn markup-menu-btn", selectedShapeType === shapeType && "active")} onClick={() => handleClick(shapeType)}>
                    <span className={`btn-icon ${iconClass}`}></span>
                    <span className='moremenu-text'>{label}</span>
                </button>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in'>
                        <p>{label}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

MarkupMenuItem.propTypes = {
    iconClass: PropTypes.string,
    shapeType: PropTypes.string,
    selectedShapeType: PropTypes.string,
    handleClick: PropTypes.func,
    label: PropTypes.string,
    fromMarkup: PropTypes.string,
};

const GenerateMarkupMenuItems = (menuItems, selectedShapeType, localisedValues, fromMarkup) => {
    return menuItems.map((menuItem) => (
        <MarkupMenuItem
            key={menuItem.shapeType}
            iconClass={menuItem.iconClass}
            shapeType={menuItem.shapeType}
            selectedShapeType={selectedShapeType}
            handleClick={
                fromMarkup === MARKUP_MENU_TYPE.MARKUP_ANNOTATION
                    ? markupService?.selectCurrentDrawing
                    : UploadFileMarkupService?.toggleShapeSelection
            } // handle for upload markup and markup
            label={localisedValues?.[menuItem.labelKey]}
            fromMarkup={fromMarkup}
        />
    ));
};

GenerateMarkupMenuItems.propTypes = {
    iconClass: PropTypes.string,
    shapeType: PropTypes.string,
    selectedShapeType: PropTypes.string,
    handleClick: PropTypes.func,
    label: PropTypes.string,
    fromMarkup: PropTypes.string,
};

export default GenerateMarkupMenuItems;
